import React, { Component } from 'react'

export class Booking extends Component {
    render() {
        return (
            <div className="title">
                <h2>Need a proper <span className="inside"> TOUR PLAN?</span></h2>
                <p> <span className="bingo"> Bingoo!! <br/> </span><br/> <span className="option">Here you will get the best tour option of your choice</span>  </p> <br/> 
            </div>
        )
    }
}

export default Booking;
